import { Close } from "@mui/icons-material";



const CloseFooter = ({
    onClick,
    optText,

}) => {
    return (
        <div className='footerNoBlur'>
            <div className='horizontalCenter'>
                <div style={{ margin: '0px 20px 10px' }}>
                    <button onClick={onClick} className='closeFooterButton'>
                        {optText ?
                            <span style={{ fontSize: '14px', fontWeight: '500', color: 'var(--app-text)' }}>{optText}</span>
                            :
                            <Close />}
                        
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CloseFooter;  